import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const watClarify = (question, evidence = []) =>
  axios.post(`${API}/wat/clarify`, { question, evidence }).then((r) => r.data);

export const watAsk = (payload) =>
  axios.post(`${API}/wat/ask`, payload).then((r) => r.data);

export const watDeeper = (caseId, depth) =>
  axios
    .get(`${API}/wat/cases/${caseId}/deeper`, { params: { depth } })
    .then((r) => r.data);

export const watChallenge = (caseId) =>
  axios.post(`${API}/wat/cases/${caseId}/challenge`).then((r) => r.data);

export const watBehind = (caseId) =>
  axios.get(`${API}/wat/cases/${caseId}/behind`).then((r) => r.data);

// Answer-first product layer
export const watExport = (caseId) =>
  axios.get(`${API}/wat/export/${caseId}`).then((r) => r.data);

export const watAnswer = (payload) =>
  axios.post(`${API}/wat/answer`, payload).then((r) => r.data);

export const watReceipt = (caseId, question = "Why?") =>
  axios.post(`${API}/wat/receipt`, { case_id: caseId, question }).then((r) => r.data);

// Phase 2 — multimodal evidence upload. Returns a non-identifying evidence_id
// plus a small provenance-preserving preview.
export const watUpload = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(`${API}/wat/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

// PRIVACY-ARCH-001 — hard delete of one WAT string + its exclusively-owned
// persisted state (backend-enforced cascade).
export const watDelete = (threadId) =>
  axios.delete(`${API}/wat/thread/${threadId}`).then((r) => r.data);

// Phase 4 — download a real portable artifact (pdf|docx|md) rendered from the
// persisted user-facing string. Returns the binary Blob.
export const watArtifact = (threadId, fmt) =>
  axios.get(`${API}/wat/artifact/${threadId}/${fmt}`, { responseType: "blob" }).then((r) => r.data);

// Phase 5 — reconstruct a NEW backend thread from an imported portable payload
// (decrypted client-side). No LLM, no original IDs; returns the new case_id so
// the restored conversation can be continued.
export const watImport = (payload) =>
  axios.post(`${API}/wat/import`, payload).then((r) => r.data);

// Phase 4/B — backend-authoritative list of formats available for this string.
export const watFormats = (threadId) =>
  axios.get(`${API}/wat/export/${threadId}`).then((r) => r.data.formats || ["pdf", "docx", "md"]);
